// @grozd/auth-client — RequireAuth wrapper, redirect helper, session reader
// Korišćen u: web-erp, web-admin (web-auth ima vlastite forme)

export { redirectToLogin, redirectToReturn } from "./redirect";
export { getCurrentUser, fetchMe, invalidateMe, isAuthenticated } from "./session";
export { logout } from "./logout";
export type { LogoutOptions } from "./logout";
export { RequireAuth, RequireSuperAdmin } from "./RequireAuth";
export type { AuthUser } from "./types";
